export default __webpack_public_path__ + "static/media/MentorMe_logo.44fb7ca1.png";